import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./common-drop-down.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./common-drop-down.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { SharedConstants } from "../../constants/shared-constants";
export let CommonDropDownComponent = class CommonDropDownComponent {
    changeDetectorRef;
    options = [];
    valueSelected = new EventEmitter();
    stateReset = new EventEmitter();
    preSelected = "";
    placeholder = "";
    doNotSort = false;
    selected = "";
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
        if (this.preSelected && this.options && this.options.indexOf(this.preSelected) < 0) {
            throw new Error(`Pre selected value ${this.preSelected} is not present in the options`);
        }
        this.refreshSelectionOptions();
        this.changeDetectorRef.detectChanges();
    }
    refreshSelectionOptions() {
        if (!this.placeholder) {
            this.placeholder = SharedConstants.PLACEHOLDER_TEXT;
        }
        if (this.preSelected) {
            this.selected = this.preSelected;
            this.valueSelected.emit(this.selected);
        }
        if (!this.doNotSort && this.options)
            this.options.sort();
    }
    emitValueChange($event) {
        const value = $event.target.value;
        if (value === this.placeholder) {
            this.stateReset.emit(true);
            return;
        }
        this.valueSelected.emit(value);
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        options: [{ type: Input }],
        valueSelected: [{ type: Output }],
        stateReset: [{ type: Output }],
        preSelected: [{ type: Input }],
        placeholder: [{ type: Input }],
        doNotSort: [{ type: Input }]
    };
};
CommonDropDownComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: "lib-drop-down[options]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CommonDropDownComponent);
